import PsychoeducationSection from "../_shared/PsychoeducationSection";
import AllergiesBlock from "../_shared/AllergiesBlock";
import HistoryBlock from "../_shared/HistoryBlock";
import MedicationsBlock from "../_shared/MedicationsBlock";
import VitalsBlock from "../_shared/VitalsBlock";
import RosBlock from "../_shared/RosBlock";
import PhysicalExamBlock from "../_shared/PhysicalExamBlock";
import AssessmentBlock from "../_shared/AssessmentBlock";
import PrescriptionsBlock from "../_shared/PrescriptionsBlock";
import ScreeningAssessmentBlock from "../_shared/ScreeningAssessmentBlock";
import VaccinesBlock from "../_shared/VaccinesBlock";
import CptCodesBlock from "../_shared/CptCodesBlock";
import {
  CarePlanTemplateList,
  OrderList,
  RenderTextWithContainerPattern,
  ReportSection,
} from "../constant";

interface PsychiatricNoteTemplateProps {
  data: any;
}

const PsychiatricNoteTemplate = ({ data }: PsychiatricNoteTemplateProps) => {
  return (
    <>
      {/* ── Subjective ── */}
      <ReportSection label="Subjective">
        <RenderTextWithContainerPattern
          label="History of Present Illness"
          val={data?.historyOfPresentIllness}
        />
        <RenderTextWithContainerPattern
          label="Subjective"
          val={data?.subjectiveFreeNote}
        />
        <AllergiesBlock data={data} />
        <HistoryBlock data={data} />
        <RenderTextWithContainerPattern label="Habits" val={data?.habits} />
        <MedicationsBlock data={data} />
      </ReportSection>

      {/* ── Objective ── */}
      <ReportSection label="Objective">
        <RenderTextWithContainerPattern
          label="Objective"
          val={data?.objectiveFreeNote}
        />
        <VitalsBlock data={data} />
        <PhysicalExamBlock data={data} />
        <RosBlock data={data} />
        <ScreeningAssessmentBlock data={data} />
      </ReportSection>

      {/* ── Assessment ── */}
      <ReportSection label="Assessment">
        <AssessmentBlock data={data} />
      </ReportSection>

      {/* ── Plan ── */}
      <ReportSection label="Plan">
        <RenderTextWithContainerPattern label="Plan" val={data?.planFreeNote} />
        <PrescriptionsBlock data={data} />
        <VaccinesBlock data={data} />
        <OrderList orders={data?.patientOrders} />
        <CptCodesBlock data={data} />
        <RenderTextWithContainerPattern
          label="Care Plan"
          val={data?.carePlan}
        />
        <CarePlanTemplateList carePlanTemplates={data?.carePlanTemplates} />
        <RenderTextWithContainerPattern
          label="Instructions"
          val={data?.instruction}
        />
      </ReportSection>

      {/* ── Follow-Up ── */}
      <ReportSection label="Follow-Up">
        <RenderTextWithContainerPattern
          label="Follow Up"
          val={data?.followUp}
        />
      </ReportSection>

      {/* ── Psychoeducation Session (shown below Follow Up only when required) ── */}
      <ReportSection label="Psychoeducation Session">
        <PsychoeducationSection data={data} />
      </ReportSection>
    </>
  );
};

export default PsychiatricNoteTemplate;
